import React from 'react';
import { useTranslation } from 'react-i18next';

// assets
import LogoText from 'shared/assets/logoText.svg';

// components
import StyledMarkdown from 'shared/StyledMarkdown';

// hooks
import { useUser } from 'shared/hooks/api/user';

// styles
import * as ChatBubbleStyled from 'eCoach/_styles/ChatBubble.style';
import {
  ResponsiveECoachSection,
  ResponsiveUserSection,
} from 'eCoach/_styles/ResponsiveChatSections';

interface ChatBubbleProps {
  children?: React.ReactNode;
  sentByUser?: boolean;
  simpleString?: string;
}

function ChatBubble({ children, sentByUser, simpleString }: ChatBubbleProps) {
  const { data: user } = useUser();
  const { t } = useTranslation();
  const name = user?.nickname || user?.first_name || t('ChatBubble.You');

  if (!sentByUser)
    return (
      <ResponsiveECoachSection>
        <ChatBubbleStyled.Section eCoach={true}>
          <ChatBubbleStyled.LogoText src={LogoText} />
          <ChatBubbleStyled.ECoachMessage>
            {simpleString ? (
              <StyledMarkdown content={simpleString} />
            ) : (
              children
            )}
          </ChatBubbleStyled.ECoachMessage>
        </ChatBubbleStyled.Section>
      </ResponsiveECoachSection>
    );

  if (sentByUser && !simpleString)
    return (
      <ResponsiveUserSection>
        <ChatBubbleStyled.Section>{children}</ChatBubbleStyled.Section>
      </ResponsiveUserSection>
    );

  return (
    <ResponsiveUserSection>
      <ChatBubbleStyled.Section>
        <ChatBubbleStyled.UserMessage>
          <ChatBubbleStyled.Label>{name}</ChatBubbleStyled.Label>
          <ChatBubbleStyled.DescriptionText>
            {simpleString}
          </ChatBubbleStyled.DescriptionText>
        </ChatBubbleStyled.UserMessage>
      </ChatBubbleStyled.Section>
    </ResponsiveUserSection>
  );
}

export default ChatBubble;
